<template>
<div>
    <Box  @close="cerrar(false)">
        <template #top>Asignar Empleados</template>
        <template #center>
            <div class="nj-card">
                <div class="nj-cols" style="grid-template-columns: 1fr auto;">
                    <div>
                        <div class="nj-label">Cliente</div>
                        <input type="text" class="nj-text" v-model="emp_nombre" placeholder="buscar empleado..." @keydown.enter="buscar()" ref="emp_nombre">
                    </div>
                    <button class="nj-button nj-align-self-end" @click="buscar()">Buscar</button>
                </div>
                <br>
                <div class="nj-cols form c3" style="grid-template-columns: 1fr 1fr; gap: 20px;">
                    <div>
                        <div class="nj-subtitle-1">Empleados para asignar</div>
                        <div class="empleadoList">
                            <div v-for="empleado in empleados" :key="empleado.emp_id" class="empleadoItem" @click="agregar(empleado)">
                                {{ empleado.emp_nombre }} {{ empleado.emp_apellido }} | DNI: {{ empleado.emp_dni }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="nj-subtitle-1">Empleados asignados</div>
                        <div class="empleadoList">
                            <div v-for="empleado in empleados_asignados" :key="empleado.emp_id" class="empleadoItem" @click="retirar(empleado)">
                                {{ empleado.emp_nombre }} {{ empleado.emp_apellido }} | DNI: {{ empleado.emp_dni }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #bottom>
            <button class="nj-button c-green" @click="asignar()"><i class="mdi mdi-content-save"></i>Asignar</button>
        </template>
    </Box>
</div>
</template>

<script>
import { ProyectoService, EmpleadoService } from "../../rest"
import Toast from "../../util/toast"
import { Box } from "../components"

export default {
    name: "ProyectoAsignarEmpleados",
    components: {
        Box,
    },
    props: {
        pry_id: {
            type: Number
        }
    },
    data() {
        return {
            emp_nombre: null,
            empleados: [],
            empleados_asignados: [],
            empleados_retirados: []
        }
    },
    methods: {
        buscarEmpleadosAsignados() {
            EmpleadoService.buscarEmpleadosAsignados({
                pry_id: this.pry_id
            }).then(
                response => {
                    this.empleados_asignados = response.data
                    this.empleados_asignados.forEach(empleado => {
                        empleado.emp_key = `current${empleado.emp_id}`
                    })
                    this.$refs["emp_nombre"].focus()
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        buscar() {
            this.empleados = []
            const request =
                EmpleadoService
                    .buscar({
                        empleado: {
                            emp_nombre: this.emp_nombre,
                            excluir_proyecto: true,
                            pry_id: this.pry_id,
                        }
                    }).then(
                        response => {
                            this.empleados = response.data
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
        },
        agregar(empleado) {
            const list = this.empleados_asignados.filter(item => item.emp_id == empleado.emp_id)
            if (list.length == 0) {
                empleado.emp_key = `added${empleado.emp_id}`
                this.empleados_asignados.push(empleado)
            } else {
                Toast.warn(`El empleado ${empleado.emp_nombre} ${empleado.emp_apellido} ya esta asignado`)
            }
        },
        retirar(empleado) {
            this.empleados_retirados.push(empleado)
            this.empleados_asignados = this.empleados_asignados.filter(item => item.emp_id != empleado.emp_id)
        },
        asignar() {
            // preparando los empelados asignados
            const empleados_asignados = this.empleados_asignados
                .filter(item => item.emp_key == `added${item.emp_id}`)
                .map(item => item.emp_id)
            // preparando los empelados retirados
            const empleados_retirados = this.empleados_retirados.map(item => item.emp_id)
            const request = {
                pry_id: this.pry_id,
                empleados_asignados,
                empleados_retirados
            }
            ProyectoService.asignarEmpleados(request).then(
                response => {
                    Toast.success(response.message)
                    this.cerrar(true)
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        cerrar() {
            this.$emit("close")
        }
    },
    mounted() {
        this.buscarEmpleadosAsignados()
    }
}
</script>

<style scoped>
.empleadoList {
    border: 1px solid #ccc;
    border-radius: var(--radius);
    padding: 8px;
}

.empleadoItem {
    cursor: pointer;
    line-height: 24px;
    padding: 2px 8px;
}

.empleadoItem:hover {
    background-color: #f2f2f2;
    border-radius: var(--radius);
}
</style>